var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHyperlink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M5.42082 6.6V14H3.71082V6.6H5.42082ZM7.52004 7.84C7.22004 7.84 6.97337 7.75333 6.78004 7.58C6.59337 7.4 6.50004 7.18 6.50004 6.92C6.50004 6.65333 6.59337 6.43333 6.78004 6.26C6.97337 6.08 7.22004 5.99 7.52004 5.99C7.81337 5.99 8.05337 6.08 8.24004 6.26C8.43337 6.43333 8.53004 6.65333 8.53004 6.92C8.53004 7.18 8.43337 7.4 8.24004 7.58C8.05337 7.75333 7.81337 7.84 7.52004 7.84ZM8.37004 8.42V14H6.66004V8.42H8.37004ZM13.0093 8.36C13.6626 8.36 14.1826 8.57333 14.5693 9C14.9626 9.42 15.1593 10 15.1593 10.74V14H13.4593V10.97C13.4593 10.5967 13.3626 10.3067 13.1693 10.1C12.9759 9.89333 12.7159 9.79 12.3893 9.79C12.0626 9.79 11.8026 9.89333 11.6093 10.1C11.4159 10.3067 11.3193 10.5967 11.3193 10.97V14H9.60926V8.42H11.3193V9.16C11.4926 8.91333 11.7259 8.72 12.0193 8.58C12.3126 8.43333 12.6426 8.36 13.0093 8.36ZM19.7575 14L18.0575 11.66V14H16.3475V6.6H18.0575V10.69L19.7475 8.42H21.8575L19.5375 11.22L21.8775 14H19.7575Z",
    fill: "#00AEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18H21",
    stroke: "#0973F8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlink);
export default __webpack_public_path__ + "static/media/hyperlink.e20e823d.svg";
export { ForwardRef as ReactComponent };